import * as React from 'react';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Alert, Button, Upload, Select, message, InputNumber, Switch } from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { getObjectValues, isNonEmptyObject, nullSafeGet } from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import { vendorsRestCrudThunksForSupplier } from '../../thunks/vendors_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import { imageUploadValidation } from '../../utils/ImageUtils';
import PhoneNumberComponent from '../PhoneNumberComponent/PhoneNumberComponentAntdV3';
import { capitalize, checkAndFormatPhoneNumber } from '../../utils/DataFormatterUtils';
import { Option } from 'antd/es/mentions';
import ClearErrors from '../clear_errors/ClearErrors';
import { VENDORS_CRUD_ACTION_CREATORS } from '../../actions/vendors_actions';
import LocationFreeForm from '../location_autocomplete/LocationFreeForm';
import { CURRENCIES } from '../../utils/DataConstants';
import EmailComponentAntdV3 from '../email_component/EmailComponentAntdV3';

require('./VendorForm.less');

interface VendorFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	formData: any;
	history: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	create: any;
	update: any;
}

class VendorForm extends React.Component<VendorFormProps, any> {
	state = {
		uploadLoading: false,
		logoUrl: null,
	};

	componentDidMount() {
		const { formData } = this.props;
		this.props.form.setFieldsValue({ logoUrl: formData.logoUrl });
	}

	handleUploadChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ uploadLoading: true });
			return;
		}
		if (info.file.status === 'done') {
			const companyLogoURL = nullSafeGet('file.response.data', info);
			this.props.form.setFieldsValue({ logoUrl: companyLogoURL });
			this.setState({
				logoUrl: companyLogoURL,
				uploadLoading: false,
			});
		}
	};

	handleSubmit = (e, submitAction) => {
		const { history, onSuccess, redirectForwardUrl, formData } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const address = values.address;

				const vendor = {
					...formData,
					id: values.id,
					name: values.name,
					isActive: values.isActive,
					vendorId: values.vendorId,
					currencyId: values.currencyId,
					paymentTerms: formData.paymentTerms,
					shippingTerms: formData.shippingTerms,
					...(isNonEmptyObject(address) && { address }),
					email: values.email,
					logoUrl: values.logoUrl,
					phoneNumber: checkAndFormatPhoneNumber(values.phoneNumber),
					defaultWarrantyMonths: values.warrantyValue
						? values.warrantyUnit === 'years'
							? values.warrantyValue * 12
							: values.warrantyValue
						: undefined,
				};

				submitAction(vendor)
					.then((record) => {
						if (redirectForwardUrl) {
							history.push(redirectForwardUrl);
						}
						if (onSuccess) {
							onSuccess(record);
						}
					})
					.catch((err) => message.error(err));
			}
		});
	};

	handleLocationAutocompleteSelect = (parsedAddress, lonLat) => {
		const { form } = this.props;
		form.setFieldsValue({
			addressInput: parsedAddress,
			'address-streetAddress1': parsedAddress.streetAddress1,
			'address-streetAddress20pt': parsedAddress.streetAddress20pt,
			'address-city': parsedAddress.city,
			'address-region': parsedAddress.region,
			'address-postcode': parsedAddress.postcode,
			'address-country': parsedAddress.country,
		});
		form.validateFields(['addressInput']);
	};

	handlePreview = (file) => {
		this.setState({
			previewImage: file.url || file.thumbUrl,
			previewVisible: true,
		});
	};

	handleCancel = () => this.setState({ previewVisible: false });

	render() {
		const { updating, creating, form, update, create, createErrors, formData, updateErrors } =
			this.props;
		const { getFieldDecorator } = form;
		const { logoUrl } = this.state;
		const isUpdate = formData && formData.id !== undefined;
		const submitAction = isUpdate ? update : create;
		const submitText = isUpdate ? 'Update vendor' : 'Create vendor';
		const isLoading = updating || creating;
		const createRawAddress = (addr) => {
			if (!addr || addr === undefined) {
				return '';
			}
			return `${addr.streetAddress1}  ${addr.city}, ${addr.region}, ${addr.postcode}, ${addr.country}`;
		};

		const rawAddress = createRawAddress(nullSafeGet('address', formData));
		getFieldDecorator('logoUrl', {
			initialValue: null,
		});
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };

		const uploadButton = (
			<div>
				<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
				<div className="ant-upload-text">Upload</div>
			</div>
		);
		let defaultWarrantyValue = formData.defaultWarrantyMonths;
		let defaultWarrantyUnit = 'months';
		if (defaultWarrantyValue && defaultWarrantyValue % 12 === 0) {
			defaultWarrantyValue = defaultWarrantyValue / 12;
			defaultWarrantyUnit = 'years';
		}

		const currencyRecordsList = getObjectValues(CURRENCIES);

		getFieldDecorator('id', { initialValue: formData.id });
		const warrantyUnits = ['months', 'years'];
		return (
			//TODO: UPGRADE FORM
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
			>
				<ClearErrors actionCreators={VENDORS_CRUD_ACTION_CREATORS} />
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				<Form.Item label="Name">
					{getFieldDecorator('name', {
						initialValue: formData.name,
						rules: [{ required: true, message: 'This field is required.' }],
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				<Form.Item label="Is Active">
					{getFieldDecorator('isActive', {
						initialValue: formData.isActive === undefined ? true : formData.isActive,
						valuePropName: 'checked',
					})(<Switch />)}
				</Form.Item>
				<Form.Item label="Vendor ID">
					{getFieldDecorator('vendorId', {
						initialValue: formData.vendorId,
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				{/*
				<Form.Item label="Payment Terms">
					{getFieldDecorator('paymentTerms', {
						initialValue: formData.paymentTerms,
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				<Form.Item label="Shipping Terms">
					{getFieldDecorator('shippingTerms', {
						initialValue: formData.shippingTerms,
					})(<Input style={{ maxWidth: 640 }} />)}
				</Form.Item>
				*/}
				<Form.Item label="Address">
					<div style={{ maxWidth: 800 }}>
						{getFieldDecorator('address', {
							initialValue: nullSafeGet('address', formData),
							rules: [
								{
									required: false,
									message: 'Please search for and select a valid address',
								},
							],
						})(<LocationFreeForm placeholder="Street Address" />)}
					</div>
				</Form.Item>

				<Form.Item label="Currency">
					{form.getFieldDecorator('currencyId', {
						rules: [{ required: true, message: 'Please select a currency for this event.' }],
						initialValue: formData.currencyId,
					})(
						<Select
							showSearch={true}
							style={{ width: 320 }}
							optionFilterProp="children"
							filterOption={(input, option) =>
								currencyRecordsList[option.props.value].displayNamePlural
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
							}
							placeholder="Currency"
						>
							{currencyRecordsList.map((currency) => (
								<Select.Option key={currency.id} value={currency.id}>
									{capitalize(currency.displayNamePlural)} ({currency.id})
								</Select.Option>
							))}
						</Select>
					)}
				</Form.Item>
				<EmailComponentAntdV3
					form={form}
					formData={formData}
					label={'Email'}
					fieldProps={{
						key: `email`,
						name: 'email',
					}}
					style={{ maxWidth: 320 }}
				/>
				<PhoneNumberComponent
					form={form}
					label="Phone Number"
					fieldProps={{
						initialValue: formData.phoneNumber,
						name: 'phoneNumber',
					}}
					style={{ maxWidth: 320 }}
				/>
				<Form.Item label="Upload your vendor's logo. Square 300x300 pixel images look best.">
					<Upload
						name="file"
						listType="picture-card"
						className="avatar-uploader"
						showUploadList={false}
						headers={uploadHeaders}
						action={`${BACKEND_URI}/api/v1/supplier/file/public/company_logo/upload`}
						beforeUpload={imageUploadValidation}
						onChange={this.handleUploadChange}
					>
						{logoUrl ? <img src={logoUrl} style={{ maxHeight: 104 }} alt="" /> : uploadButton}
					</Upload>
				</Form.Item>
				<Form.Item label="Default Warranty Period">
					<div>
						{getFieldDecorator('warrantyValue', {
							initialValue: defaultWarrantyValue,
							rules: [{ required: false, message: 'This field is required.' }],
						})(<InputNumber min={1} max={365} />)}
						{getFieldDecorator('warrantyUnit', {
							initialValue: defaultWarrantyUnit || 'months',
							rules: [{ required: false, message: 'This field is required.' }],
						})(
							<Select style={{ maxWidth: 100, marginLeft: 8 }}>
								{warrantyUnits.map((f) => (
									<Option key={f} value={f}>
										{f}
									</Option>
								))}
							</Select>
						)}
					</div>
				</Form.Item>
				<Form.Item>
					<Button
						type="primary"
						htmlType="submit"
						loading={isLoading}
						className="contactForm__button"
					>
						{submitText}
					</Button>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	formData: ownProps.formData,
	redirectForwardUrl: ownProps.redirectForwardUrl,
	onSuccess: ownProps.onSuccess,

	createErrors: state.vendors.createErrors,
	updateErrors: state.vendors.updateErrors,
	creating: state.vendors.creating,
	updating: state.vendors.updating,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	update: (entity) => dispatch(vendorsRestCrudThunksForSupplier.update(entity)),
	create: (entity) => dispatch(vendorsRestCrudThunksForSupplier.create(entity)),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Form.create<VendorFormProps>()(VendorForm))
);
